import gql from 'graphql-tag';
import apollo from '../apollo';

const ADD_SURVEY_PROJECT_MUTATE = gql`
  mutation createSurveyProject($input: CreateSurveyProjectInput!) {
    createSurveyProject(input: $input) {
      id
    }
  }
`;

export const createSurveyProject = input => apollo
  .mutate({
    mutation: ADD_SURVEY_PROJECT_MUTATE,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const SURVEY_PROJECT_FILE_LIST = gql`
  query surveyProjectFileList($accountId: ID!, $id: ID!) {
    account(id: $accountId) {
      id
      surveyProject(id: $id) {
        id
        surveyImports {
          id
          fileName
          messages
          status
          createdOn
          updatedOn
        }
      }
    }
  }
`;

export const getSurveyImportFileList = ({ id, accountId }) => apollo
  .query({
    query: SURVEY_PROJECT_FILE_LIST,
    variables: {
      id,
      accountId,
    },
    fetchPolicy: 'network-only',
  })
  .then((res) => {
    const { surveyProject } = res.data.account;
    return surveyProject.surveyImports;
  });

export const FILE_ACTIVATION = gql`
  mutation($input: ActivateSurveyProjectInput!) {
    activateSurveyProject(input: $input) {
      id
    }
  }
`;

export const activeDefinition = input => apollo
  .mutate({
    mutation: FILE_ACTIVATION,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const DELETE_SURVEY_IMPORT_MUTATION = gql`
  mutation($input: DeleteSurveyImportInput!) {
    deleteSurveyImport(input: $input) {
      name
    }
  }
`;

export const removeSurveyImport = input => apollo
  .mutate({
    mutation: DELETE_SURVEY_IMPORT_MUTATION,
    variables: {
      input,
    },
  })
  .then(res => res.data);
